import React, { FC, MutableRefObject, ReactElement, useEffect, useState } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'
import { GenericGuard } from './GenericGuard'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { ReactState } from '../../React/Common/Types/Types'
import { RouteAccessibilityDTO } from '../Types/Types'
import { IsVarEmpty } from '../../NonReact/utils/GlobalFunctions'
import { JSONResponse } from '../../NonReact/common/Types/Types'
import { getRouteAvailability } from '../../React/Common/API/RouteAPI'

type Props = {
    route: RouteID
    children: ReactElement
}

export const RouteGuard: FC<Props> = ({ route, children }: Props): ReactElement => {
    const [currentRoute, setCurrentRoute]: ReactState<Nullable<RouteID>> = useState<Nullable<RouteID>>()
    const [routeAccessibility, setRouteAccessibility]: ReactState<Nullable<RouteAccessibilityDTO>> =
        useState<Nullable<RouteAccessibilityDTO>>(null)

    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    useEffect((): void => {
        if (route !== currentRoute) {
            setCurrentRoute(route)

            getRouteAvailability(route)
                .then((data: JSONResponse<RouteAccessibilityDTO>): void => {
                    if (isMounted.current) setRouteAccessibility(data)
                })
                .catch((): void => {
                    if (isMounted.current) setRouteAccessibility({ accessible: false, redirect: RouteID.AUTH })
                })
                .finally((): void => {
                    if (isMounted.current) setCurrentRoute(route)
                })
        }
    }, [route, currentRoute])

    return (
        <GenericGuard
            checkIsTrue={IsVarEmpty(currentRoute) || currentRoute !== route ? null : routeAccessibility?.accessible}
            redirectPath={`/${routeAccessibility?.redirect}`}
        >
            {children}
        </GenericGuard>
    )
}
